import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';

import auth from '../../common/utils/auth';
import BlurLoadImage from '../components/BlurLoadImage';
import { imageOfTheDay } from '../../backgroundImages';

const GetStarted = ({ t }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current !== null) {
      ref.current.focus();
    }
  }, []);

  return (
    <>
      <div
        style={{
          position: 'fixed',
          background: imageOfTheDay.background,
          pointerEvents: 'none',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <BlurLoadImage
          style={{
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '100%',
          }}
          src={imageOfTheDay.src}
          lowResSrc={imageOfTheDay.lowResSrc}
        />
      </div>
      <section className="hero is-fullheight">
        <div className="hero-body">
          <div className="container">
            <div className="columns is-centered">
              <div className="column is-5-tablet is-4-desktop is-3-widescreen">
                <Formik
                  initialValues={{}}
                  onSubmit={() => {
                    return auth.login();
                  }}
                >
                  {({ isSubmitting }) => (
                    <Form className="panel has-background-white">
                      <div className="panel-heading">{t('sign-in-to-orthodx')}</div>
                      <div className="panel-block">{t('click-below-to-sign-in')}</div>

                      <div className="panel-block">
                        <button
                          ref={ref}
                          type="submit"
                          data-test="continue-to-login"
                          disabled={isSubmitting}
                          className="button is-primary is-fullwidth"
                        >
                          <b>{t('continue')}</b>
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <a
          style={{
            color: imageOfTheDay.color,
            opacity: 0.7,
            textDecoration: 'none',
            padding: '4px 6px',
            fontFamily:
              '-apple-system, BlinkMacSystemFont, &quot;San Francisco&quot;, &quot;Helvetica Neue&quot;, Helvetica, Ubuntu, Roboto, Noto, &quot;Segoe UI&quot;, Arial, sans-serif',
            fontSize: '12px',
            fontWeight: 'bold',
            lineHeight: '1.2',
            display: 'inline-block',
            zIndex: 1,
            borderRadius: '3px',
          }}
          href={imageOfTheDay.link}
          target="_blank"
          rel="noopener noreferrer"
          title={`Photo by ${imageOfTheDay.credit}`}
        >
          <span style={{ display: 'inline-block', padding: '2px 3px' }}>
            {imageOfTheDay.credit}
          </span>
        </a>
      </section>
    </>
  );
};

export default withTranslation()(GetStarted);

GetStarted.propTypes = {
  t: PropTypes.func.isRequired,
};
